import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useAuth } from "../AuthContext";
import { useLang } from "../LanguageContext";
import { formatApiError } from "../utils";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const redirect = new URLSearchParams(location.search).get("redirect") || "/account";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin" : redirect);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="login-page" className="pt-32 min-h-screen flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <p className="qw-overline mb-4 text-center">Atelier · Privé</p>
        <h1 className="font-serif text-4xl md:text-5xl text-foreground text-center mb-4 font-light">
          {t.auth.loginTitle}
        </h1>
        <p className="text-center text-sm text-muted-foreground mb-12">{t.auth.loginSubtitle}</p>
        <form onSubmit={submit} className="space-y-8" data-testid="login-form">
          <div>
            <label className="qw-overline block mb-2">{t.auth.email}</label>
            <input
              data-testid="login-email-input"
              required type="email" value={email}
              onChange={(e) => setEmail(e.target.value)} className="qw-input"
            />
          </div>
          <div>
            <label className="qw-overline block mb-2">{t.auth.password}</label>
            <input
              data-testid="login-password-input"
              required type="password" value={password}
              onChange={(e) => setPassword(e.target.value)} className="qw-input"
            />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
          <button
            type="submit" disabled={busy}
            data-testid="login-submit-btn"
            className="qw-btn qw-btn-primary w-full justify-center disabled:opacity-60"
          >
            {busy ? t.auth.loggingIn : t.auth.login}
            {!busy && <ArrowUpRight size={14} strokeWidth={1.2} />}
          </button>
          <p className="text-center text-sm text-muted-foreground pt-4">
            {t.auth.noAccount}{" "}
            <Link to="/signup" className="qw-link-underline text-primary">{t.auth.signupHere}</Link>
          </p>
        </form>
      </div>
    </main>
  );
}
